/**
 * DiscoverySpotlights 스타일
 * @description 머리줄과 목록 사이는 `MasonryList` 가 위에 두는 16 이 맡는다. 상태 문구는
 *   앱 `DiscoveryBody.styles` 의 `state`·`error` 와 같은 값이다.
 */
export const discoverySpotlightsStyles = {
  root: "flex w-full flex-col",
  state:
    "fw-l1 w-full py-[var(--fw-space-inset-xxl)] text-center text-[var(--fw-color-content-neutral-tertiary)]",
  error:
    "flex w-full flex-col items-center gap-[var(--fw-space-gap-md)] py-[var(--fw-space-inset-xxl)]",
};

/** 카드가 가장 넓게 서는 폭 — 데스크톱 4열(약 300) */
export const DISCOVERY_SPOTLIGHT_IMAGE_SIZES =
  "(min-width: 1280px) 300px, (min-width: 768px) 33vw, 50vw";
